/**
 * Shared Clarity commercial-document design tokens (Proposal PDF / BOM / Invoice).
 * 6-digit hex only — pdfkit misreads CSS 8-digit alpha hex.
 */
export const CLARITY_DOC_COLORS = {
  cream: "#FAFAF7",
  navy: "#1A2744",
  /** ~70% navy on cream — equivalent of CSS `#1A2744B3`. */
  navyMuted: "#5D667A",
  accent: "#C8A96A",
  muted: "#6B7280",
  desc: "#4B5563",
  rowBorder: "#E5E7EB",
  softStroke: "#D1D5DB",
} as const;

export const CLARITY_DOC_LAYOUT = {
  /** A4 content margins (pt) — matches quotation pdfkit renderer. */
  marginX: 42,
  marginY: 40,
  pageBottom: 802,
} as const;

export const CLARITY_DOC_TYPE = {
  sectionLabel: 8,
  body: 9,
  metaLabel: 8,
  metaValue: 9,
  title: 12,
  display: 16,
  footer: 7,
  lineGap: 1.5,
} as const;
